import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["avatarImg", "badgeProps", "bodyContent", "checkboxProps", "convertTxtToBlue", "disabled", "featuredIcon", "headerText", "iconCardHeading", "isSelected", "mobileBreakpoint", "mobileBreakpointContainerRef", "onChangeCheckbox", "onChangeRadio", "paymentIconId", "primaryButtonProps", "radioButtonProps", "secondaryButtonProps", "selectionType", "showFeaturedIcon", "size", "subHeaderText", "summary", "supportingText", "text", "type", "value"];
/* eslint-disable max-lines */
import React, { useState, useRef, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { PaymentIcon } from '@im/ui-lib/zenith/PaymentIcon';
import { useConvertToMobile } from '../utils/useConvertToMobile';
import { Avatar } from '../Avatar';
import { Badge } from '../Badge';
import { FeaturedIcon } from '../FeaturedIcon';
import { Radio } from '../Radio';
import { Checkbox } from '../Checkbox';
import { BodyContent } from './internal/BodyContent';
import Typography from '@mui/material/Typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SelectionGroup(_ref) {
  var avatarImg = _ref.avatarImg,
    badgeProps = _ref.badgeProps,
    controlledBodyContent = _ref.bodyContent,
    checkboxProps = _ref.checkboxProps,
    convertTxtToBlue = _ref.convertTxtToBlue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    featuredIcon = _ref.featuredIcon,
    headerText = _ref.headerText,
    iconCardHeading = _ref.iconCardHeading,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    mobileBreakpoint = _ref.mobileBreakpoint,
    mobileBreakpointContainerRef = _ref.mobileBreakpointContainerRef,
    onChangeCheckbox = _ref.onChangeCheckbox,
    onChangeRadio = _ref.onChangeRadio,
    paymentIconId = _ref.paymentIconId,
    primaryButtonProps = _ref.primaryButtonProps,
    radioButtonProps = _ref.radioButtonProps,
    secondaryButtonProps = _ref.secondaryButtonProps,
    selectionType = _ref.selectionType,
    _ref$showFeaturedIcon = _ref.showFeaturedIcon,
    showFeaturedIcon = _ref$showFeaturedIcon === void 0 ? true : _ref$showFeaturedIcon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    subHeaderText = _ref.subHeaderText,
    summary = _ref.summary,
    supportingText = _ref.supportingText,
    text = _ref.text,
    type = _ref.type,
    value = _ref.value,
    other = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var isMobile = useConvertToMobile(mobileBreakpoint, mobileBreakpointContainerRef);
  var checkboxRef = useRef(null);
  var radioRef = useRef(null);
  var _useState = useState(isSelected),
    _useState2 = _slicedToArray(_useState, 2),
    isCheckboxSelected = _useState2[0],
    setIsCheckboxSelected = _useState2[1];
  var handleCheckboxSelected = function handleCheckboxSelected() {
    setIsCheckboxSelected(!isCheckboxSelected);
  };
  useEffect(function () {
    onChangeCheckbox && onChangeCheckbox(checkboxRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheckboxSelected]);
  return /*#__PURE__*/_jsxs(Root, _extends({
    className: (type !== 'Icon card' ? 'selection-group-card' : '') + (disabled ? ' disabled' : ''),
    onClick: selectionType === 'multi-select' || type === 'Checkbox' ? handleCheckboxSelected : function () {
      return onChangeRadio && onChangeRadio(radioRef);
    },
    selected: selectionType === 'multi-select' ? isCheckboxSelected : isSelected,
    tabIndex: 0
  }, other, {
    "data-element": "Root",
    "data-component": "SelectionGroup",
    "data-source-file": "SelectionGroup.tsx",
    children: [/*#__PURE__*/_jsxs(Stack, {
      flexDirection: "row",
      sx: {
        alignItems: type === 'Icon card' || type === 'Icon simple' && !summary ? 'center' : 'initial',
        columnGap: '12px',
        padding: '16px',
        paddingTop: isSelected ? '15px' : '16px'
      },
      "data-element": "Stack",
      "data-source-file": "SelectionGroup.tsx",
      children: [type === 'Avatar' && /*#__PURE__*/_jsx(Avatar, {
        size: size,
        src: avatarImg
      }), type === 'Checkbox' && /*#__PURE__*/_jsx(Box, {
        sx: {
          mt: '3px'
        },
        children: /*#__PURE__*/_jsx(Checkbox, _extends({
          checked: isCheckboxSelected,
          disabled: disabled,
          inputRef: checkboxRef,
          size: size,
          value: value
        }, checkboxProps))
      }), (type === 'Icon card' || type === 'Icon simple') && showFeaturedIcon && featuredIcon && /*#__PURE__*/_jsx(FeaturedIcon, {
        Icon: featuredIcon,
        color: disabled ? 'gray' : 'primary',
        iconTheme: "light-circle-outline",
        size: size
      }), type === 'Payment icon' && paymentIconId && /*#__PURE__*/_jsx(PaymentIcon, {
        id: paymentIconId,
        size: "md"
      }), type === 'Radio button' && /*#__PURE__*/_jsx(Box, {
        sx: {
          mt: '3px'
        },
        children: /*#__PURE__*/_jsx(Radio, _extends({
          checked: isSelected,
          disabled: disabled,
          inputRef: radioRef,
          size: size,
          value: value
        }, radioButtonProps))
      }), type === 'Icon card' ? /*#__PURE__*/_jsx(Typography, {
        color: convertTxtToBlue != null && convertTxtToBlue(value) ? theme.palette.primary[800] : theme.palette.gray[700],
        variant: size === 'md' ? 'text-md-semibold' : 'text-sm-semibold',
        children: headerText
      }) : /*#__PURE__*/_jsxs(Stack, {
        children: [/*#__PURE__*/_jsx(BodyContent, {
          convertTxtToBlue: convertTxtToBlue,
          disabled: disabled,
          headerText: headerText,
          primaryButtonProps: primaryButtonProps,
          secondaryButtonProps: secondaryButtonProps,
          size: size,
          subHeaderText: subHeaderText,
          summary: summary,
          type: type,
          value: value
        }), controlledBodyContent && /*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[600],
          variant: size === 'md' ? 'text-md-regular' : 'text-sm-regular',
          children: controlledBodyContent
        })]
      }), type !== 'Radio button' && type !== 'Checkbox' && /*#__PURE__*/_jsx(Box, {
        sx: {
          ml: 'auto'
        },
        children: selectionType === 'single-select' ? /*#__PURE__*/_jsx(Radio, _extends({
          checked: isSelected,
          disabled: disabled,
          inputRef: radioRef,
          size: size,
          value: value
        }, radioButtonProps)) : /*#__PURE__*/_jsx(Checkbox, _extends({
          checked: isCheckboxSelected,
          disabled: disabled,
          inputRef: checkboxRef,
          size: size,
          value: value
        }, checkboxProps))
      })]
    }), type === 'Icon card' && /*#__PURE__*/_jsxs(Stack, {
      className: "icon-card-body",
      flexDirection: "row",
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      rowGap: "16px",
      sx: {
        borderRadius: '0px 0px 12px 12px',
        borderTop: isSelected ? "2px solid ".concat(theme.palette.primary[600]) : "1px solid ".concat(theme.palette.gray[200]),
        padding: theme.spacing(4),
        position: 'relative'
      },
      children: [badgeProps && /*#__PURE__*/_jsx(Box, {
        sx: {
          ml: isMobile ? theme.spacing(4) : 0,
          position: isMobile ? 'inherit' : 'absolute',
          right: theme.spacing(4)
        },
        children: /*#__PURE__*/_jsx(Badge, _extends({}, badgeProps, {
          size: size
        }))
      }), controlledBodyContent ? /*#__PURE__*/_jsx(Typography, {
        color: theme.palette.gray[600],
        variant: size === 'md' ? 'text-md-regular' : 'text-sm-regular',
        children: controlledBodyContent
      }) : /*#__PURE__*/_jsx(BodyContent, {
        convertTxtToBlue: convertTxtToBlue,
        disabled: disabled,
        size: size,
        summary: summary,
        supportingText: supportingText,
        text: text,
        type: type,
        value: value
      })]
    })]
  }));
}
var Root = styled(Stack)(function (_ref2) {
  var selected = _ref2.selected,
    theme = _ref2.theme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    '&.disabled': _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      '& .MuiCheckbox-root, .MuiRadio-root': {
        '.MuiSvgIcon-root': {
          backgroundColor: "".concat(theme.palette.gray[100], " !important"),
          border: 'none !important'
        }
      }
    }, ".MuiSvgIcon-root", {
      color: theme.palette.gray[300]
    }), ".icon-card-body", {
      background: theme.palette.gray[50],
      borderTop: "1px solid ".concat(theme.palette.gray[200])
    }), "background", "".concat(theme.palette.gray[50], " !important")), "border", "1px solid ".concat(theme.palette.gray[200], " !important")), "cursor", 'default'), "pointerEvents", 'none')
  }, "&:focus-visible", _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".icon-card-body", {
    borderTop: selected ? "2px solid ".concat(theme.palette.primary[600]) : "1px solid ".concat(theme.palette.primary[300])
  }), "border", selected ? "2px solid ".concat(theme.palette.primary[600]) : "1px solid ".concat(theme.palette.primary[300])), "boxShadow", "0px 0px 0px 4px ".concat(theme.palette.primary[100])), "outline", 'none')), "&:hover", _defineProperty(_defineProperty(_defineProperty({
    '& .MuiCheckbox-root, .MuiRadio-root': {
      '&.Mui-checked': {
        '.MuiSvgIcon-root': {
          backgroundColor: theme.palette.blue[100],
          border: 'solid',
          borderColor: theme.palette.blue[600],
          borderWidth: 1
        },
        background: 'none'
      },
      '.MuiSvgIcon-root': {
        backgroundColor: theme.palette.primary[100],
        border: 'solid',
        borderColor: theme.palette.primary[600],
        borderWidth: 1
      },
      background: 'none'
    }
  }, ".icon-card-body", {
    borderTop: selected ? "2px solid ".concat(theme.palette.primary[600]) : "1px solid ".concat(theme.palette.primary[300])
  }), "background", selected && theme.palette.primary[50]), "border", selected ? "2px solid ".concat(theme.palette.primary[600]) : "1px solid ".concat(theme.palette.primary[300]))), ".icon-card-body", {
    background: 'white'
  }), "background", selected ? theme.palette.primary[50] : ''), "border", selected ? "2px solid ".concat(theme.palette.primary[600]) : "1px solid ".concat(theme.palette.gray[200])), "borderRadius", '12px'), "cursor", 'pointer'), "flexDirection", 'column'), "marginBottom", '12px');
});